import React, { FC, useEffect } from 'react';
import { Layout } from 'antd';
import { useDispatch } from 'react-redux';
import AppContent from '../components/AppContent/AppContent';
import SideMenu from '../components/SideMenu/SideMenu';
import AppFooter from '../components/AppFooter';
import GameListName from '../components/GameListName/GameListName';
import classes from './DefaultLayout.module.less';
import DefaultHeader from '../components/Headers/DefaultHeader';
import { fetchMe } from '../views/auth/slice/actions';
import { refreshActiveList } from '../views/student-words-list/slice/actions';

const DefaultLayout: FC = ({ children }) => {
  const dispatch = useDispatch();

  // Profil przy wejściu do części zalogowanej — obejmuje i świeże logowanie, i start z zapisanym
  // tokenem. Ten sam układ ma też strona 404, oglądana bywa bez logowania: wtedy nie ma kogo pytać.
  // U ucznia do tego aktywna lista: od ostatniej wizyty mogła zniknąć albo się zmienić.
  useEffect(() => {
    if (localStorage.getItem('token')) {
      dispatch(fetchMe());
      dispatch(refreshActiveList());
    }
  }, [dispatch]);

  return (
    <Layout className={classes.main}>
      <DefaultHeader />
      <Layout className={classes.content}>
        <SideMenu />
        <AppContent id="main">
          <GameListName />
          {children}
        </AppContent>
      </Layout>
      <AppFooter />
    </Layout>
  );
};

export default DefaultLayout;
